import { MODAL_SET_DATA, MODAL_SET_SHOW } from "../actions/types";

const initialState = {
    title: null,
    content: null,
    show: false,
    centered: true,
    size: null,
    toFront: false,
    onClose: () => {},
};

const modalReducer = (state = initialState, action) => {
    switch (action.type) {
        case MODAL_SET_DATA:
            return {
                ...state,
                ...action.payload,
                size: action.payload?.size,
                toFront: action.payload?.toFront || false,
            };

        case MODAL_SET_SHOW:
            return {
                ...state,
                show: action.payload,
                onClose: initialState.onClose,
            };

        default:
            return state;
    }
};

export default modalReducer;
